import { Controller } from '@hotwired/stimulus';

const ACTIVE_CLASSES = ['bg-white-1000', 'text-black-700', 'font-semibold', 'shadow-xs'];
const INACTIVE_CLASSES = ['text-black-400', 'font-medium'];

// Reorders the rendered L/B quote cards by the server-computed rank (no page reload),
// reversing value-bearing cards for a descending toggle and keeping blanks last.
export default class extends Controller {
  static targets = ['option', 'card', 'list', 'directionIcon'];
  static values = {
    criterion: { type: String, default: 'price' },
    direction: { type: String, default: 'asc' },
  };

  connect() {
    this.updateDirectionIcon();
    this.reorder();
  }

  select(event) {
    const { criterion } = event.params;
    if (!criterion) return;

    this.criterionValue = criterion;
    this.directionValue = 'asc';

    this.optionTargets.forEach((option) => {
      const active = option === event.currentTarget;
      ACTIVE_CLASSES.forEach((className) => option.classList.toggle(className, active));
      INACTIVE_CLASSES.forEach((className) => option.classList.toggle(className, !active));
    });

    this.updateDirectionIcon();
    this.reorder();
  }

  toggleDirection() {
    this.directionValue = this.directionValue === 'asc' ? 'desc' : 'asc';
    this.updateDirectionIcon();
    this.reorder();
  }

  updateDirectionIcon() {
    if (!this.hasDirectionIconTarget) return;

    this.directionIconTarget.classList.toggle('-scale-y-100', this.directionValue === 'desc');
  }

  reorder() {
    if (!this.hasListTarget) return;

    const availability = this.criterionValue === 'availability';
    const rankKey = availability ? 'rankAvailability' : 'rankPrice';
    const blankKey = availability ? 'blankAvailability' : 'blankPrice';
    const byRank = (a, b) => Number(a.dataset[rankKey]) - Number(b.dataset[rankKey]);

    const cards = [...this.cardTargets];
    const present = cards.filter((card) => card.dataset[blankKey] !== 'true').sort(byRank);
    const blanks = cards.filter((card) => card.dataset[blankKey] === 'true').sort(byRank);

    if (this.directionValue === 'desc') present.reverse();

    [...present, ...blanks].forEach((card) => this.listTarget.appendChild(card));
  }
}
